<template>
  <ValidationProvider
    :name="name"
    :rules="rules"
    class="field"
    slim
    :class="['checkbox-card', { 'border-checked': checked, 'border-danger': errorChecked }]"
  >
    <div class="col-12 d-flex justify-content-between m-1">
      <div :class="classes">
        <div class="checkbox-card__title">{{ title }}</div>
        <div class="checkbox-card__subtitle">{{ subtitle }}</div>
      </div>
      <div class="checkbox-card__toggle">
        <label class="btn-switch btn-switch--toggle" :for="id">
          <input
            role="checkbox"
            :aria-label="name"
            :id="id"
            :data-testid="id"
            :name="name"
            type="checkbox"
            :checked="checked"
            :value="checked"
            @change="$emit('toggle', checked)"
            :disabled="disabled"
          />
          <span class="slider slider__lg" :class="disabled && 'slider--disabled'"></span>
        </label>
      </div>
    </div>
    <div class="col-12 justify-content-start">
      <slot />
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
export default {
  name: 'CheckboxCard',
  components: {
    ValidationProvider
  },
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String
    },
    checked: {
      type: Boolean,
      default: false
    },
    errorChecked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.checkbox-card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding: 1.5rem;
  margin-bottom: 1rem;
  background: color('white');
  border: 1px solid color('medium-grey');
  border-radius: 0.8rem;

  transition: border .5s ease;

  &__title {
    font-weight: bold;
    font-size: 1.4rem;
    padding-bottom: 0.1rem;
    color: color('mine-shaft');
    margin-bottom: 0.625rem;
  }

  &__subtitle {
    font-size: 1.4rem;
    color: color('dark-grey');
  }

  &__iata {
    display: flex;
    flex-direction: column;
    color: color('mine-shaft');
    font-size: 1.3rem;
  }

  &__responsive_div_buttons {
    max-width: 70%;
  }
  &__toggle {
    margin-top: 0.5rem;
  }
}
.slider {
  &__lg {
    transform: scale(1.4);
  }
  &--disabled {
    opacity: 0.6;
  }
}
.border-checked {
  border: 1px solid color('mine-shaft') !important;
}
.border-error {
  border: 1px solid color('primary') !important;
}
</style>
